import { Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { MarketingTags } from 'typings'
import { IconHash } from '../../../../icons'
import { Tag, TagsList } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { messages } from './messages'

type Props = {
  config: MarketingTags | undefined
  onEdit: () => void
  onRemove: () => void
}

export function MarketingTagsView(props: Props) {
  const { config, onEdit, onRemove } = props

  const { $t } = useIntl()

  if (!config) return null

  const { tags, operator } = config

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconHash />
      </RuleIcon>
      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          operator,
          count: tags.length,
        })}
      </RuleDescription>
      <RuleContent>
        <TagsList>
          {tags.map((tag) => (
            <Tag key={tag}>{tag}</Tag>
          ))}
        </TagsList>
      </RuleContent>
      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
